<template>
  <div id="addBanks">
    <div class="container">
      <headNav :routeAddress="address">
        <div slot="headNavText">{{$t('message.my_yhzhgl')}}</div>
      </headNav>
      <div class="banksBox">
        <van-swipe-cell v-for="(item,index) in banksArr" :key="item.id" v-if="banksArr.length>0">
          <div class="bank" @click="setDefault(item)" :class="'bank'+index">
            <div>
              <div style="display: flex;align-items: center;justify-content: space-between">
                <div style="background: #fff;border-radius: 10px;padding: 3px 5px;display: flex;align-items: center"><img :src="item.logo" alt=""></div>
                <div>
                  <div class="setBank">
                    <div><span :style="item.is_default==1?defaultColor:noColor" v-if="item.is_default==1">{{$t('message.default')}}</span><span style="color: #FFA242;border-color: #FFA242;margin-left: 5px" @click="delBanks(item)">chỉnh sửa</span></div>
                    <div v-if="item.is_verify==1">{{$t('message.yhy')}}</div>
                    <div v-if="item.is_verify==2">{{$t('message.hy_w')}}</div>
                    <div v-if="item.is_verify==3">{{$t('message.hy_error')}}</div>
                  </div>
                </div>
              </div>
              <div style="text-align: center;font-size: 0.7rem;color: #fff;padding: 0.6rem 0 0">
                {{item.bank_card}}
              </div>
            </div>
          </div>
          <!--          <van-button-->
          <!--            slot="right"-->
          <!--            square-->
          <!--            :text="$t('message.del')"-->
          <!--            type="danger"-->
          <!--            class="delete-button"-->
          <!--            @click="delBanks(item)"-->
          <!--          />-->
        </van-swipe-cell>
        <div style="text-align: center;padding: 3.5rem 0 1.5rem" v-if="noBankCard">
          <img src="../../../assets/images/3x/noCard.png" alt="" style="height: 2.59rem;width: 5.06rem">
        </div>
        <router-link to="/home/my/setBanks/addBanks">
          <van-button block round style="margin-top: 15px" v-show="showBtn" id="add_bank_btn">+
            {{$t('message.add_bank')}}
          </van-button>
        </router-link>
        <div style="font-size: 0.32rem;color: #B8B7B7;text-align: center;padding-top: 0.6rem" v-if="noBankCard">
          {{$t('message.bind_bank_account')}}
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {getBanksNews, sassSearchBanksList, deBankCard, postRenInfo, delBank} from '../../../ports/port'

  export default {
    name: "addBanks",
    data() {
      return {
        show: false,
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        banksArr: [],//银行卡列表
        defaultColor: {
          color: '#fff',
          border: '1px solid #fff'
        },
        noColor: {
          color: 'transparent',
          border: '1px solid transparent'
        },
        showBtn: false,
        noBankCard:false,
        address:'/home/my'
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      if(this.$route.query.prev != undefined){
        this.address='/borrow';
      }else{
        this.address='/home/my';
      }
      //展示个人银行卡
      sassSearchBanksList({userid: this.tk.userid})
        .then(res => {
          if (res.data.code == 200) {
            let res1 = res.data.data;
            this.banksArr = res1;
            this.showBtn = true;
            this.banksArr.forEach(function (elem, index) {
              elem['setDefault'] = false;
            });
            res1.length>0?this.noBankCard=false:this.noBankCard=true;
          }
        });
    },
    methods: {
      setDefault(a) {
        if (a.is_default == '0') {
          this.$dialog.confirm({
            message: this.$t('message.com_edit_bank'),
            confirmButtonText: this.$t('message.determine'),
            cancelButtonText: this.$t('message.cancel')
          }).then(() => {
            deBankCard({userid: this.tk.userid, bankConut: a.bank_card})
              .then(res => {
                let _this = this;
                this.$notify({
                  type: 'success', message: this.$t('message.set_success'), onOpened: function () {
                    _this.$router.go(0);
                  }
                });//设置成功

              })
          }).catch(() => {

          });
        }
      },
      //删除银行卡
      delBanks(a) {
        this.$router.push({'path':'/home/my/setBanks/addBanks',query:{userBank:JSON.stringify(a)}})
        // delBank({userid: a.userid, bank_count: a.bank_count})
        //   .then(res => {
        //     if (res.data.code == 200) {
        //       let _this = this;
        //       this.$notify({
        //         type: 'success', message: this.$t('message.delete_success'), onClose: function () {
        //           window.location.reload()
        //           ;
        //         }
        //       })
        //     } else if (res.data.code == 202) {
        //       this.$notify({type: 'danger', message: this.$t('message.no_delete_1bank')});
        //     }
        //   })
        //   .catch(err=>{
        //     this.$store.commit('edit',false);//关闭全局的loading
        //     if(err.toString().indexOf('timeout')!=-1){
        //       this.$toast({message:this.$t("message.service_timeout"),type:'danger',icon:'fail'});
        //     }
        //   })
      }
    }
  }
</script>

<style scoped lang="scss">
  #addBanks {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .container {
      background: #F2F4FB;
      padding: 0 0 1px;
      /*min-height: 77vh;*/
      flex: 1;

      .title {
        text-align: center;
        background: white;
        font-size: 16px;
        padding: 10px 0;
        border-bottom: 1px solid #F2F4FB;
        position: relative;

        i {
          position: absolute;
          left: 20px;
          font-size: 20px;
        }
      }

      .banksBox {
        padding: 1.6rem 15px 0;
        .delete-button {
          height: 100%;
          background: red;
          border-color: red;
        }
        .bank {
          background: white;
          padding: 15px;
          border-radius: 10px;
          margin-bottom: 10px;

          img {
            height: 26px;
            border-radius: 40px;
          }
          .bankName {
            display: inline-block;
            padding-left: 8px;

            div:nth-child(1) {
              color: #989797;
              font-size: 12px;
              margin-bottom: 8px;
            }

            div:nth-child(2) {
              color: #fff;
              font-size: 0.74rem;
            }
          }

          .setBank {
            text-align: right;

            div {
              span {
                display: inline-block;
                padding: 2px 12px;;
                border: 1px solid #FFA242;
                color: #FFA242;
                border-radius: 8px;
                font-size: 12px;
              }
            }

            div:nth-child(2) {
              font-size: 0.1rem;
              color: red;
            }
          }
        }
      }

      #add_bank_btn {
        @include defaultBtn;
        background-color: #fff!important;
        color: #242424;
        border: 1px solid #dad8d8;
        box-shadow: 0rem 0rem 0rem 0rem rgba(145, 145, 145, 0.4);
        border-radius: 8px!important;
      }
    }

    /deep/ .van-dialog__content {
      text-align: center;
    }
    .bank0{
      background: linear-gradient(90deg, #FF7C6D, #FF5A6B)!important;
    }
    .bank1{
      background: linear-gradient(90deg, #0C9093, #11827C)!important;
    }
    .bank2{
      background: linear-gradient(90deg, #FF7C6D, #FF5A6B)!important;
    }
    .bank3{
      background: linear-gradient(90deg, #0C9093, #11827C)!important;
    }
    .bank4{
      background: linear-gradient(90deg, #FF7C6D, #FF5A6B)!important;
    }
    .bank5{
      background: linear-gradient(90deg, #0C9093, #11827C)!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/editInfos/setBanks.vue